module.exports = __webpack_public_path__ + "img/dynamic_2.f9b7fcd0.png";